import React, { useEffect, useState } from "react";
import DynamicTable from "../../components/DynamicTable";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import ErrorMessage from "../../components/ErrorMessage";
import DeleteAllModal from "../../modals/DeleteAllModal";
import DeleteRowModal from "../../modals/DeleteRowModal";
import RestoreRowModal from "../../modals/RestoreRowModal";
import RestoreAllModal from "../../modals/RestoreAllModal";
import { Box, Button, Collapse } from "@mui/material";
import { KeyboardArrowUp, KeyboardArrowDown } from "@mui/icons-material";

import {
  getAction,
  softDeleteAction,
  softDeleteAllAction,
  deleteRowAction,
  deleteAllAction,
  restoreRowAction,
  restoreAllAction,
} from "../../store/actions/contacts";

import { DecodeUserRole, DecodeUsername } from "../../hooks/userData";
const moment = require("moment");

const Contacts = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.contacts.data);
  const loading = useSelector((state) => state.contacts.loading);
  const error = useSelector((state) => state.contacts.error);

  const [showDeleteRowModal, setDeleteRowModal] = useState(false);
  const [showDeleteAllModal, setDeleteAllModal] = useState(false);
  const [showRestoreRowModal, setRestoreRowModal] = useState(false);
  const [showRestoreAllModal, setRestoreAllModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedTable, setSelectedTable] = useState(null);
  const [showDeletedTables, setShowDeletedTables] = useState(false);

  const userRole = DecodeUserRole();
  const username = DecodeUsername();

  useEffect(() => {
    dispatch(getAction());
  }, [dispatch]);

  const activeData = data
    ?.filter((item) => !item.isDeleted)
    .map((item) => {
      const { createdAt, updatedAt, isDeleted, deletedAt, deletedBy, ...rest } =
        item;

      return {
        ...rest,
      };
    });

  const deletedData = data
    ?.filter((item) => item.isDeleted)
    .map((item) => {
      const { createdAt, updatedAt, isDeleted, ...rest } = item;

      return {
        ...rest,
        deletedAt: moment(item.deletedAt).format("DD/MM/YYYY hh:mm A"),
      };
    });

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "5em" }}>
      {(userRole === "admin" || userRole === "superadmin") && (
        <Box>
          {loading ? (
            <Loader />
          ) : error ? (
            <ErrorMessage message={error} />
          ) : (
            <DynamicTable
              data={activeData}
              setDeleteAllModal={setDeleteAllModal}
              setDeleteRowModal={setDeleteRowModal}
              setSelectedRow={setSelectedRow}
              table="Contacts"
              setSelectedTable={setSelectedTable}
              canCreate={false}
              canEdit={false}
            />
          )}
        </Box>
      )}

      {userRole === "superadmin" && (
        <Box>
          <Button onClick={() => setShowDeletedTables(!showDeletedTables)}>
            {showDeletedTables
              ? "Hide Deleted Contacts"
              : "Show Deleted Contacts"}
            {showDeletedTables ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </Button>

          <Collapse in={showDeletedTables}>
            {loading ? (
              <Loader />
            ) : error ? (
              <ErrorMessage message={error} />
            ) : (
              <>
                <RestoreRowModal
                  onClose={() => setRestoreRowModal(false)}
                  showRestoreRowModal={showRestoreRowModal}
                  id={selectedRow?.id}
                  table={selectedTable}
                  action={restoreRowAction}
                  username={username}
                />

                <RestoreAllModal
                  onClose={() => setRestoreAllModal(false)}
                  showRestoreAllModal={showRestoreAllModal}
                  table={selectedTable}
                  action={restoreAllAction}
                  username={username}
                />

                <DeleteRowModal
                  onClose={() => setDeleteRowModal(false)}
                  showDeleteRowModal={showDeleteRowModal}
                  id={selectedRow?.id}
                  table={selectedTable}
                  action={
                    selectedTable === "Deleted Contacts"
                      ? deleteRowAction
                      : softDeleteAction
                  }
                  username={username}
                />

                <DeleteAllModal
                  onClose={() => setDeleteAllModal(false)}
                  showDeleteAllModal={showDeleteAllModal}
                  table={selectedTable}
                  action={
                    selectedTable === "Deleted Contacts"
                      ? deleteAllAction
                      : softDeleteAllAction
                  }
                  username={username}
                />

                <DynamicTable
                  data={deletedData}
                  canEdit={false}
                  canCreate={false}
                  canRestore
                  setRestoreRowModal={setRestoreRowModal}
                  setRestoreAllModal={setRestoreAllModal}
                  setDeleteRowModal={setDeleteRowModal}
                  setDeleteAllModal={setDeleteAllModal}
                  setSelectedRow={setSelectedRow}
                  table="Deleted Contacts"
                  setSelectedTable={setSelectedTable}
                />
              </>
            )}
          </Collapse>
        </Box>
      )}
    </Box>
  );
};

export default Contacts;
